import { render, staticRenderFns } from "./LeonidaFederazioniSportiveNazionaliEdit.vue?vue&type=template&id=19ad946f"
import script from "./LeonidaFederazioniSportiveNazionaliEdit.vue?vue&type=script&lang=js"
export * from "./LeonidaFederazioniSportiveNazionaliEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports